var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.products = {
	init: function() {
		$('#select--type, #select--material, #select--system').on('change', site.products.updateVisibility);
	},

	updateVisibility: function() {
		var $cards = $('.category .card');
		$cards.each(function() {
			$(this).hide();
		});

		var $selectorMaterial = $('#select--material').val();
		var $selectorType = $('#select--type').val();
		var $selectorSystem = $('#select--system').val();

		var $cardsToShow = $cards;

		if ($selectorMaterial !== 'all' && $selectorType !== 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorType) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial === 'all' && $selectorType !== 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorType) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType === 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType !== 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorType);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType === 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorMaterial);
			});
		} else if ($selectorMaterial === 'all' && $selectorType !== 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorType);
			});
		} else if ($selectorMaterial === 'all' && $selectorType === 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorSystem);
			});
		}



		$cardsToShow.each(function() {
			$(this).show();
		});
	}
};

site.selectedItemFrontpage = {
	init: function () {
		var $items = $('.item');
		$items.each(function () {
			$(this).hide();
		})

		var $wrap = $('.wrap');
		var $defaultItem = $wrap.find('.pic_1');

		$defaultItem.each(function () {
			$(this).show();
		});

		$('.smallImg').on('click', site.selectedItemFrontpage.updateSelected);
	},

	updateSelected: function () {
		var $items = $('.owl-item.active .item');
		$items.each(function () {
			$(this).hide();
		})

		var $itemsToShow = $items;

		$selectedItem = $(this);

		if ($selectedItem.hasClass('pic_1')){
			$itemsToShow = $items.filter(function () {
				return $(this).is('.pic_1');
			})
		}
		else if ($selectedItem.hasClass('pic_2')) {
			$itemsToShow = $items.filter(function () {
				return $(this).is('.pic_2');
			})
		}
		else if ($selectedItem.hasClass('pic_3')) {
			$itemsToShow = $items.filter(function () {
				return $(this).is('.pic_3');
			})
		}

		$itemsToShow.each(function() {
			$(this).show();
		});

	}
}

site.categoryFilter = {
	init: function() {
		$('.category__wrap').on('click', 'button', site.categoryFilter.updateCategory);
	},

	updateCategory: function () {
		var $cat = $('.category');
		$cat.each(function() {
			$(this).hide();
		});

		var $categorySelected = $(this).val();
		var $catToShow = $cat;

		if ($categorySelected === 'fasteignir') {
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'skip-og-batar'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'fyrirtaeki'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'velar-og-veidarfaeri'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else {
			$catToShow = $cat.filter(function () {
				return $(this).is('.skip-og-batar');
			})
		}

		$catToShow.each(function() {
			$(this).show();
		});

	}
};

site.frontpage = {
	init: function() {

	}
};

site.multiselect = {
	init: function(selector) {
		$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
		$(selector).multiselect({
			sortable: true,
			searchable: true
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.selectedItemFrontpage.init();
	}

	if ($('.carousel__image').length > 1) {
		site.owl.init('.productView .carousel__images', {
			items: 1,
			nav: true,
			navText: ['', ''],
			autoHeight: true,
			dots: false
		});
	}

	site.owl.init('.box_extras_carousel .extras_carousel', {
		items: 1,
		nav: true,
		navText: ['', ''],
		autoHeight: true,
		dots: true
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
